var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-divider"},[_c('div',{staticClass:"fd-label",style:(("color: " + _vm.color))},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"border",style:(("background: " + _vm.color))})])}
var staticRenderFns = []

export { render, staticRenderFns }